import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import stock from 'api/stock'
import { UserContext } from 'stores/UserStore'
import { exportAsTablePdfFile } from 'utils/pdf'
import { exportAsExcelFile } from 'utils/excel'
import moment from 'moment'
import * as _ from 'lodash'
import { descompressResponse } from 'utils/decompress'

export const StockContext = React.createContext({})

export const StockProvider = ({ children }) => {
    const { t } = useTranslation()
    const [isLoading, setLoading] = useState(false)
    const [isLoadingTable, setLoadingTable] = useState(false)
    const [isLoadingPdf, setLoadingPdf] = useState(false)
    const [isLoadingExcel, setLoadingExcel] = useState(false)
    const [tableData, setTableData] = useState([])
    const [tableDetailsData, setTableDetailsData] = useState([])
    const [materialStatusPieces, setMaterialStatusPieces] = useState([])
    const [pieces, setPieces] = useState([])
    const [tableTotalPieces, setTableTotalPiecesData] = useState(0)
    const [tableTotalInvoicePieces, setTableTotalInvoicePieces] = useState(0)
    const [date, setDate] = useState()
 
    const [options, setOptions] = useState({
        client : [],
        center: [],
        status: [],
        warehouse: []
    })

    const [queryData, setQueryData] = useState({
        ippn: '',
        client: '',
        center: '',
        sot: '',
        nmIncomingNumber: '',
        nmIncomingDescription: '',
        nmActualNumber: '',
        nmActualDescription: '',
        materialStatus: '',
        invoice: '',
        warehouse: '',
      })
    const { idToken } = useContext(UserContext)

    const formartIppn = (ippn) => {
        if (ippn.length === 13) {
            return ippn ? ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1}).*/, '$1.$2.$3.$4-$5') : ''
          } else if (ippn.length === 14) {
            return ippn ? ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1})(\d{1}).*/, '$1.$2.$3.$4-$5#$6') : ''
          } else {
            return ippn
        }
    }

    const formartDate = date => moment(date).format('DD/MM/YYYY')

    const getServiceStockData = () => {
        console.debug(idToken)
        console.log(console.debug(idToken))
        setLoading(true)
        stock.getServiceStock(idToken).then(data => {
            data = data.body ? data.body : data
            const descompressData = descompressResponse(data)
            setTableData(descompressData.tableData)
            setMaterialStatusPieces(descompressData.piecesStatus)
            setPieces(descompressData.pieces)
            setOptions(descompressData.options)
            setDate(descompressData.date)
            setLoading(false)
        }).catch(error => {
            console.debug(error)
        })
    }

    const getServiceDetailsData = (formState) => {
        setTableTotalPiecesData(0)
        console.debug(idToken)
        setQueryData(formState)
        setLoadingTable(true)
        formState.compress = true
      return stock.getServiceDetails(idToken, formState).then(data => {
          data = data.body ? data.body : data
          const descompressData = descompressResponse(data)
            setTableDetailsData(descompressData.tableData)
            setTableTotalPiecesData(descompressData.totalPieces)
            setTableTotalInvoicePieces(descompressData.totalInvoicePieces)
            setLoadingTable(false)
        }).catch(error => {
            console.debug(error)
        })
    }

    const exportToPdf = (filteredColumns) => {
        setLoadingPdf(true)
        const exportData = _.cloneDeep(tableDetailsData)
        const reportData = []
        const columnsData = []

        let filters = 'Filters: '
        filters += queryData.invoice ? t('service.inputInvoice') + ' ' + queryData.invoice : ''
        filters += queryData.ippn ? t('service.inputIppn') + ' ' + queryData.ippn : ''
        filters += queryData.stock ? t('service.inputStock') + ' ' + queryData.stock : ''
        filters += queryData.invoiceType ? t('service.inputInvoiceType') + ' ' + queryData.invoiceType : ''
        filters += queryData.warehouse ? t('service.inputCenter') + ' ' + queryData.warehouse : ''
        filters += queryData.client ? t('service.inputClient') + ' ' + queryData.client : ''
        filters += queryData.materialStatus ? t('service.inputMaterialStatus') + ' ' + queryData.materialStatus : ''
        filters += queryData.description ? t('service.inputDescription') + ' ' + queryData.description : ''
        filters += queryData.sot ? t('service.inputSot') + ' ' + queryData.sot : ''
        filters += queryData.nm ? t('service.inputNm') + ' ' + queryData.nm : ''
        const header = {
            title: t('service.pageTitle'),
            subTitle: filters,
            logo: 'Smart'
        }
        for (const column of filteredColumns) {
            columnsData.push(column.Header)
        }
        reportData.push(columnsData)
        for (const data of exportData) {
            const rowData = []
            data['ippn'] = formartIppn(data['ippn'])
            data['invoiceDate'] = formartDate(data['invoiceDate'])
            data['incomingDate'] = formartDate(data['incomingDate'])
            data['statusMaterialDate'] = formartDate(data['statusMaterialDate'])

            for (const column of filteredColumns) {
                let value = data[column.id] ? data[column.id] : ''
                rowData.push(value)
            }
            reportData.push(rowData)
        }
        const options = {
            pageOrientation: 'landscape',
            pageSize: 'A3',
            watermark: false,
            zebraStyle: true
        }
        exportAsTablePdfFile(header, reportData, options)
        setTimeout(() => {
            setLoadingPdf(false)
        }, 3000)

    }

    const exportToExcel = (filteredColumns) => {
        setLoadingExcel(true)
        const reportData = []
        const exportData = _.cloneDeep(tableDetailsData)
        for (const data of exportData) {
            data['ippn'] = formartIppn(data['ippn'])
            data['invoiceDate'] = formartDate(data['invoiceDate'])
            data['incomingDate'] = formartDate(data['incomingDate'])
            data['statusMaterialDate'] = formartDate(data['statusMaterialDate'])
            data['qtyIncoming'] = (data['qtyIncoming'] === "0") ? data['qtyIncoming'] : parseInt(data['qtyIncoming'])
            data['qty'] = parseInt(data['qty'])
            const rowData = {}

            for (const column of filteredColumns) {
                const value = data[column.id] ? data[column.id] : ''
                rowData[column.Header] = value
            }

            reportData.push(rowData)
        }
        exportAsExcelFile(reportData, t('service.pageTitle'))
        setTimeout(() => {
            setLoadingExcel(false)
        }, 3000)
    }

    return (
        <StockContext.Provider value={{
            tableData,
            materialStatusPieces,
            pieces,
            tableDetailsData,
            tableTotalPieces,
            queryData,
            isLoading,
            isLoadingTable,
            isLoadingPdf,
            isLoadingExcel,
            date,
            getServiceStockData,
            getServiceDetailsData,
            exportToPdf,
            exportToExcel,
            options,
            tableTotalInvoicePieces
        }}>
            {children}
        </StockContext.Provider>
    )
}